export const clamp = (v: number, lo: number, hi: number): number => Math.min(hi, Math.max(lo, v))
export const lerpScalar = (a: number, b: number, t: number): number => a + (b - a) * t
export const degrees = (rad: number): number => (rad * 180) / Math.PI
export const radians = (deg: number): number => (deg * Math.PI) / 180
